/* eslint-disable */
import React, {Component} from 'react'
import cookie from 'react-cookies'
import {Link} from 'react-router-dom'
import {message} from 'antd'
import http from '../../../Component/Interceptor/Interseptor'
import BASE_PUBLIC from '../../BaseComponent/BASEPUBLIC'
import BASE_MANAGE from '../../BaseComponent/BASEMANAGE'
import USER_MANAGE from '../../BaseComponent/USERMANAGE'
import SearchableCombo from '../../BaseComponent/searchableCombo'

class AddTerminal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      code: 0,
      type: '',
      brand: '',
      serialNumber: '',
      error: '',
      externalId: null,
      accounts: [],
      drivers: [],
      accountId: 0,
      typeAccountTitle: '',
      assigneeName: '',
      assignee: null
    }
  }

  componentDidMount() {
    this.getAccounts()
    this.getDriver()
  }
  getAccounts = () => {
    http
      .get(`${BASE_PUBLIC.BASE__PUBLIC_HASTERMINAL_ACCOUNTS}`, {})
      .then((res) => {
        if (res.data.error === null) {
          this.setState({
            accounts: res.data.object
          })
        } else {
          message.error('خطای ' + res.data.errorCode + ' : ' + res.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }
  getDriver = () => {
    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((res) => {
        if (res.data.error === null) {
          var drivers = res.data.object
          for (let i = 0; i < drivers.length; i++) {
            drivers[i]['value'] = drivers[i].personId
            drivers[i]['label'] = drivers[i].personId + ' - ' + drivers[i].name
          }
          this.setState({
            drivers
          })
        } else {
          message.error('خطای ' + res.data.errorCode + ' : ' + res.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  changeInputnum = (e) => {
    let name = e.target.name
    let value = parseInt(e.target.value)
    this.setState({
      [name]: value
    })
  }

  changeInputs = (e) => {
    let name = e.target.name
    let value = e.target.value
    this.setState({
      [name]: value
    })
  }
  onChangeSelectDriver = (e) => {
    let value = e.target.value
    this.setState({
      assignee: value
    })
  }
  onChangeSelectAccount = (e) => {
    let value = e.target.value
    this.setState({
      accountId: value
    })
  }

  onAddClick = () => {
    let code = this.state.code
    let externalId = +this.state.externalId
    let brand = this.state.brand
    let serialNumber = this.state.serialNumber
    let typeAccountId = this.state.accountId
    let assignee = this.state.assignee !== null ? this.state.assignee.personId : ''

    let codeError = false
    let typeError = false
    let brandError = false
    let serialNumberError = false
    let typeAccountIdError = false
    let assigneeError = false

    let formError = false

    if (code === 0) {
      formError = true
      codeError = true
      message.error('کد ترمینال را وارد کنید')
    } else {
      if (!codeError) {
      }
    }

    if (brand == '') {
      formError = true
      brandError = true
      message.error('برند را وارد کنید')
    } else {
      if (!brandError) {
      }
    }
    if (serialNumber == '') {
      formError = true
      serialNumberError = true
      message.error('شماره سریال را وارد کنید')
    } else {
      if (!serialNumberError) {
      }
    }
    if (typeAccountId == 0) {
      formError = true
      typeAccountIdError = true
      message.error('روش پرداخت  را انتخاب کنید')
    } else {
      if (!typeAccountIdError) {
      }
    }

    // else {
    //     if (!codeError && !typeError && !brandError && !serialNumberError && !typeAccountIdError) {
    //         this.setState({
    //             error: ''
    //         })
    //     }
    // }

    if (!formError) {
      let data = {
        code,
        brand,
        externalId,
        serialNumber,
        typeAccountId,
        assignee
      }

      http
        .post(`${BASE_MANAGE.BASE_MANAGE_PAYMENT_ADD_TERMINAL}`, data)
        .then((response) => {
          if (response.data.error == null) {
            message.success('ترمینال اضافه شد')
            this.props.history.push('/Base/payment/terminals')
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {})
    }
  }

  onSubmit = (e) => {
    e.preventDefault()
  }
  getValueDriver = (assignee) => {
    this.setState({
      assignee
    })
  }

  render() {
    let {accounts, drivers} = this.state
    return (
      <div className="rtl">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>اطلاعات پایه</Link>
            </li>
            <li>
              <Link to={'/Payment'}>پرداخت</Link>
            </li>
            <li>ثبت ترمینال</li>
          </ul>
          <div className="mt-2 bg-white container-fluid p-3">
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-3">
                <label htmlFor="name">
                  کد ترمینال<span className="requireFiled">*</span>
                </label>
                <input
                  type="number"
                  name="code"
                  className="form-control"
                  placeholder="کد ترمینال را وارد کنید"
                  onChange={this.changeInputnum}
                />
              </div>
              <div className="col-xs-12 col-sm-6 col-md-3">
                <label htmlFor="brand">
                  برند<span className="requireFiled">*</span>
                </label>
                <input
                  type="text"
                  name="brand"
                  className="form-control"
                  onChange={this.changeInputs}
                  placeholder="برند را وارد کنید"
                />
              </div>
              <div className="col-xs-12 col-sm-6 col-md-3">
                <label htmlFor="serialNumber">
                  {' '}
                  شماره سریال <span className="requireFiled">*</span>
                </label>
                <input
                  type="text"
                  name="serialNumber"
                  className="form-control"
                  placeholder="شماره سریال  را وارد کنید"
                  onChange={this.changeInputs}
                />
              </div>

              <div className="col-xs-12 col-sm-6 col-md-3">
                <label htmlFor="externalId"> External Id</label>
                <input
                  type="number"
                  name="externalId"
                  className="form-control"
                  placeholder="External Id را وارد کنید"
                  onChange={this.changeInputs}
                  value={this.state.externalId}
                />
              </div>

              <div className="col-xs-12 col-sm-6 col-md-3">
                <label htmlFor="روش پرداخت">
                  روش پرداخت<span className="requireFiled">*</span>{' '}
                </label>
                <select
                  className="custom-select"
                  id="isInput"
                  onChange={this.onChangeSelectAccount}
                  name="typeAccountTitle"
                  tabIndex="2"
                  placeholder="روش پرداخت را انتخاب کنید"
                >
                  <option value={null}>---------</option>
                  {accounts.map((account) => (
                    <option value={account.id}>{account.title}</option>
                  ))}
                </select>
              </div>
              <div className="col-xs-12 col-sm-6 col-md-3 mt-sm-2">
                <SearchableCombo
                  options={this.state.drivers}
                  getValueCombo={this.getValueDriver}
                  lableText="رساننده"
                  placeholder="------"
                  isClearable={true}
                  isMulti={false}
                  isDisabled={false}
                />
                {/*<label htmlFor="روش پرداخت"> رساننده </label>*/}
                {/*<select className="custom-select" id="assignee" onChange={this.onChangeSelectDriver}*/}
                {/*        name="assignee"*/}
                {/*        tabIndex='2'*/}
                {/*        placeholder="راننده را انتخاب کنید"*/}
                {/*>*/}
                {/*    <option*/}
                {/*        value={null}>---------</option>*/}
                {/*    {drivers.map((driver,index)=>(<option*/}
                {/*            value= {driver.personId}*/}
                {/*            key={index}*/}
                {/*        >{driver.name}</option>)*/}
                {/*    )}*/}
                {/*</select>*/}
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-3 mt-sm-2">
                <button className="btn mx-0" style={{background: '#f7941e'}} onClick={this.onAddClick}>
                  ثبت ترمینال
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AddTerminal
